// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"3e1f6444","238":"4790c50f","375":"e0091d5d","796":"e0091d5d","841":"e0091d5d"}[chunkId] + ".chunk.css";
};